//@flow
import get from 'lodash.get';

export const getQueryParam = (uriRef: string, paramName: string) => {
    const paramsString = get(uriRef.split('?'), '[1]');
    const searchParams = new URLSearchParams(paramsString);
    return searchParams.get(paramName);
};
